import { FadeUp, Overline } from "@/components/motion";
import { useContent } from "@/lib/content";

const SPOTS = [
  {
    img: "/images/marktplatz.jpg",
    title: "Marktplatz & Altstadt",
    text: "Wochenmarkt, Cafés und Fachwerk: Dülmens lebendige Altstadt beginnt direkt vor unserer Tür — hier flaniert und verweilt man gern.",
    tag: "Direkt vor der Tür",
  },
  {
    img: "/images/nonnenturm.jpg",
    title: "Der Nonnenturm",
    text: "Das Wahrzeichen der Stadt ist nur 4 Gehminuten vom Hotel entfernt — Teil der mittelalterlichen Stadtbefestigung aus dem 14. Jahrhundert.",
    tag: "Wahrzeichen",
  },
  {
    img: "/images/wildpferde.jpg",
    title: "Wildpferde in der Merfelder Bruch",
    text: "Nur 10 Minuten vom Hotel: die letzten Wildpferde Europas in freier Wildbahn — ein Naturschauspiel, das es nur in Dülmen gibt.",
    tag: "Ausflugstipp",
  },
];

export default function RegionSection() {
  const c = useContent();
  const spots = c.region_spots?.length ? c.region_spots : SPOTS;
  return (
    <section id="region" className="py-24 lg:py-36 bg-sand" data-testid="region-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <FadeUp className="max-w-2xl">
          <Overline>{c.region_overline}</Overline>
          <h2 className="mt-4 font-serif font-medium text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight text-forest">
            {c.region_title_1} <em className="italic text-terra">{c.region_title_2}</em>
          </h2>
        </FadeUp>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {spots.map((s, i) => (
            <FadeUp key={s.title} delay={0.12 * i}>
              <article className="group relative overflow-hidden rounded-3xl aspect-[3/4] md:aspect-[4/5] shadow-xl shadow-forest/10" data-testid={`region-card-${i}`}>
                <img
                  src={s.img}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-forest-dark/85 via-forest-dark/25 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-7">
                  <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">{s.tag}</span>
                  <h3 className="mt-2 font-serif text-2xl sm:text-3xl font-semibold text-sand">{s.title}</h3>
                  <p className="mt-2 text-sm text-sand/80 leading-relaxed max-w-md">{s.text}</p>
                </div>
              </article>
            </FadeUp>
          ))}
        </div>
        <p className="mt-6 text-[11px] text-ink/40 text-center" data-testid="region-photo-credit">
          Fotos: Dietmar Rabich / Wikimedia Commons (CC BY-SA 4.0)
        </p>
      </div>
    </section>
  );
}
